import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ServiceForm from '../components/ServiceForm';
import useServices from '../useServices';

const Create = () => {
  const navigate = useNavigate();
  const { createService } = useServices();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      const result = await createService(data);
      if (result) {
        navigate('../');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <ServiceForm
      onSubmit={handleSubmit}
      loading={loading}
    />
  );
};

export default Create;